<template>
  <div class="login">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label prop="account">
        <el-input
          v-if="flag1"
          v-model="ruleForm.account"
          placeholder="企业名称/手机号"
          inputblur="inputblur"
          @keyup.enter.native="submitForm('ruleForm')"
        ></el-input>
        <el-input
          v-else
          v-model="ruleForm.account"
          placeholder="企业名称/手机号"
          @blur="getFocus()"
          @keyup.enter.native="submitForm('ruleForm')"
        ></el-input>
      </el-form-item>
      <el-form-item label prop="password">
        <el-input
          v-if="flag2"
          type="password"
          v-model="ruleForm.password"
          placeholder="密码"
          inputblur="inputblur"
          @keyup.enter.native="submitForm('ruleForm')"
        ></el-input>
        <el-input
          v-else
          type="password"
          v-model="ruleForm.password"
          placeholder="密码"
          @blur="getPassword()"
          @keyup.enter.native="submitForm('ruleForm')"
        ></el-input>
      </el-form-item>
      <el-form-item label prop="imageCode">
        <el-input
          v-if="flag3"
          class="code_txt"
          v-model="ruleForm.imageCode"
          placeholder="图形验证码"
          inputblur="inputblur"
          @keyup.enter.native="submitForm('ruleForm')"
        ></el-input>
        <el-input
          v-else
          class="code_txt"
          v-model="ruleForm.imageCode"
          placeholder="图形验证码"
          @blur="getImagecode()"
          @keyup.enter.native="submitForm('ruleForm')"
        ></el-input>
        <div class="img_code" @click="refreshCode">
          <img :src="img" alt />
          <!-- <span v-html="img"></span> -->
        </div>
      </el-form-item>
      <el-form-item class="sub_button">
        <el-button
          class="button_login"
          type="primary"
          @click="submitForm('ruleForm')"
          >登录</el-button
        >
      </el-form-item>
      <el-form-item class="clearfix">
        <div class="public_style forget_password" @click="forgetPassword">
          忘记密码
        </div>
        <div class="public_style registration">
          <span>没有账号&nbsp;</span>
          <span @click="pageJump">立即注册</span>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  // 获取图形验证码
  ApiImagecode,
  // 发送手机验证码
  ApiTelCode,
  ApipasswordLogin,
} from "@/common/js/api.js";
export default {
  name: "PassWordLogin",
  props: ["reset", "towncode"],
  components: {},
  mounted() {
    // 获取图形验证码
    this.getImageCode();
  },
  data() {
    return {
      img: null,
      flag1: false,
      flag2: false,
      flag3: false,
      ruleForm: {
        account: "",
        password: "",
        imageCode: "",
        loginType: 0,
        ftCode: "",
      },

      rules: {
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [
          { required: true, message: "请输入用户密码", trigger: "blur" },
        ],
        imageCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { max: 4, message: "长度为4个字符", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    getFocus() {
      this.flag1 = true;
    },
    getPassword() {
      this.flag2 = true;
    },
    getImagecode() {
      this.flag3 = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.onSubmit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async onSubmit() {
      let form = this.$lodash.cloneDeep(this.ruleForm);
      form.password = this.$md5(form.password);
      let res = await ApipasswordLogin(form);
      if (res.code != 200) {
        this.getImageCode();
        return;
      }
      // console.log(res);
      if (res.code == 200) {
        this.$message({
          message: "登录成功",
          type: "success",
        });
        const userInfo = res.result.userInfo;
        this.Cookies.set(
          "legalName",
          userInfo.contactName || userInfo.instition
        );
        this.Cookies.set("registedType", userInfo.registedType);
        this.Cookies.set("tokenClient", res.result.token);

        this.Cookies.set("institutionName", userInfo.instition);
        this.Cookies.set("identifyCode", userInfo.identifyCode);
        this.Cookies.set("riskToken", res.result.token);
        this.Cookies.set("lastTime", userInfo.recentLoginTime);
        this.setMenu();
      }
    },

    setMenu() {
      const code = this.Cookies.get("identifyCode");
      if (code && code.slice(0, 2) == "WR") {
        this.$router.push("/ReportPlatform/ReportList");
      } else {
        this.$router.push("/UC/User?first=1");
      }
    },

    // "测试123" 17610101900  123  "202cb962ac59075b964b07152d234b70"

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    pageJump() {
      if (this.towncode) {
        this.$router.push({
          path: "Registered",
          query: {
            TownCode: this.towncode,
          },
        });
      } else {
        this.$confirm("请点击确认跳转首页，选择小镇后再注册", "未选择小镇", {
          confirmButtonText: "确定",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.$router.push({
              path: "/Homepage",
            });
          })
          .catch(() => {
            this.$message({
              type: "warning",
              message: "已取消注册",
            });
          });
      }
    },
    forgetPassword() {
      this.$router.push({
        path: "ResetPassword",
        query: {
          TownCode: this.$route.query.TownCode,
        },
      });
    },
    // 刷新验证码
    refreshCode() {
      this.getImageCode();
    },
    // 获取图形验证码
    getImageCode() {
      ApiImagecode({})
        .then((res) => {
          this.img =
            "data:image/png;base64," +
            btoa(
              new Uint8Array(res).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            );
          // console.log(this.img);
        })
        .catch((res) => {});
    },
  },
  watch: {
    reset(val) {
      if (val) {
        this.resetForm("ruleForm");
      }
    },
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.login {
  form {
    padding-top: 25px;
  }
  ::v-deep  .el-input__inner {
    height: 46px;
    background: #f5f5f5 !important;
  }
  /* 失去焦点改变背景颜色 */
  ::v-deep  .el-input__inner[inputblur="inputblur"] {
    /* background:#E9F0FD; */
    background: #f5f5f5 !important;
  }
  ::v-deep  .el-form-item__content .button_login {
    width: 100%;
    height: 36px;
    border: 0;
    background: #3099fc;
    border-radius: 6px;
  }
  ::v-deep  .el-form-item__content {
    margin-bottom: 24px;
    margin-left: 0 !important;
  }
  ::v-deep  .sub_button .el-form-item__content {
    margin-bottom: 10px !important;
    margin-top: 14px;
  }
}

.public_style {
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  color: #3165ff;
}
.registration span:nth-child(1) {
  color: #b6bcc2;
  cursor: default;
}
// .registration {
//   float: left;
// }
.forget_password {
  float: right;
}
.code_txt {
  width: calc(100% - 100px - 10px);
}
.img_code {
  cursor: pointer;
  width: 100px;
  float: right;
  border: 1px solid #ccc;
}
</style>